import { useSearchParams } from "react-router-dom";
import { useOrganizationShowQuery } from "@/admin/entities/organizations";
import {
  getColumnsConfig,
  getMobileColumnsConfig,
  getTextsConfig,
} from "./config";
import { getTableData, mapColumns } from "./mappers";

/**
 * Feature-специфичные хуки для управления организациями
 * Комбинируют entity-логику с UI-специфичными потребностями
 */

/**
 * Основной хук для feature управления организациями
 * Предоставляет всю необходимую конфигурацию и логику для UI компонента
 */
export function useOrganizationsManagement() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  // Используем entity хук для загрузки данных организации
  useOrganizationShowQuery(id, id === null);

  return {
    // Конфигурация таблицы
    columns: getColumnsConfig(),
    mobileColumns: getMobileColumnsConfig(),
    mapColumns,

    // Трансформация данных
    getTableData,

    // Текстовые метки
    texts: getTextsConfig(),
  };
}

/**
 * Хук для получения конфигурации колонок таблицы
 */
export function useOrganizationsTableConfig() {
  return {
    columns: getColumnsConfig(),
    mapColumns,
  };
}

/**
 * Хук для получения текстовых меток интерфейса
 */
export function useOrganizationsTexts() {
  return getTextsConfig();
}
